module.exports = __webpack_public_path__ + "assets/img/bg-line-mecha-7dbf06b1.png";